<div>
  <h2 mat-dialog-title class="dialog-header text-white p-b-0 border-bottom-none paramount-font-bold xx-large">Paramount
    Global –
    Business to Business
    Terms of
    Use
  </h2>
  <h3 class="text-white p-l-25 paramount-font-bold x-large">Effective Date: January 31<sup>st</sup>, 2026</h3>

  <!-- <button mat-icon-button [mat-dialog-close]="true" class="close-button" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button> -->
</div>
<mat-dialog-content class="dialog-content">
  <div class="modal-loading" *ngIf="loading">
    <mat-spinner diameter="40"></mat-spinner>
    <div class="loading-text">Loading…</div>
  </div>

  <form *ngIf="!loading" [formGroup]="form">
    <mat-card class="bg-color">
      <div>
        <ol class="ol-style">
          <li class="text-white">Acceptance of Terms of Use
            <p>
              These terms and conditions of use (the “Terms”) govern your use of any information services or
              hosted applications (“Services”) provided by Paramount Skydance Corporation or its affiliates
              (“Paramount”). By using any Services that links to these Terms, you are bound by these
              Terms along with any other separately negotiated instrument pertaining to the Services
              provided. If you are using any Services on behalf of your employer, you represent that you have
              the authority to bind your employer to these Terms. In the event of a conflict between the terms
              of your employer’s separately negotiated instrument and these Terms, then the separately
              negotiated instrument shall govern.
            </p>
          </li>

          <li class="text-white">Registration and Access Controls
            <p>
              You are responsible for the confidentiality of your login credentials. You are responsible for all
              activities that occur from your login credentials. Your login credentials are for your personal use
              only. If you believe that someone is using any of your credentials, please contact Paramount
              immediately. Paramount is not responsible for any loss or damage resulting from your failure to
              notify Paramount of unauthorized use. You must provide Paramount accurate and complete
              information and must update such information when it changes.
            </p>
          </li>

          <li class="text-white">Compliance with Laws
            <p>
              You must comply with all applicable laws. You may access the Services solely for legitimate
              business purposes and may not otherwise copy, distribute, publish, display or perform or create
              derivative works of the Services without Paramount permission.
            </p>
          </li>

          <li class="text-white">Changes to These Terms of Use
            <p>
              Paramount may change these Terms at any time, so Paramount encourages you to review the
              Terms periodically. Paramount will notify you by posting a revised copy of these Terms online.
              Any changes to these Terms will become effective as of the date the revised Terms are posted. If
              you continue to use any Services after Paramount changes the Terms, you accept all changes
              effective as of the date of the revision. The date at the top of the Terms tells you when it was last
              updated. If you do not agree with the Terms or any changes Paramount makes, please do not
              continue to use the Services.
            </p>
          </li>

          <li class="text-white">Acceptable Use
            <p>
              You may not use any Services to do the following or assist others to do the following:
            </p>
            <ol type="a" style="margin: 0px 30px;">
              <li>sublicense, assign, sell, or lease the Services or content to third parties without a
                Paramount agreement; </li>
              <li>use the Services for any commercial purpose unrelated to your business relationship with
                Paramount; </li>
              <li> remove any copyright, trademark or other proprietary notations from content on the
                Services; </li>
              <li> threaten, defame, stalk, abuse, or harass other persons, or engage in illegal activities; </li>
              <li> link to any Services from external, non-Paramount websites (“Third Party Sites”); </li>
              <li> transmit any material that is inappropriate, profane, vulgar, offensive, false, disparaging,
                defamatory, obscene, illegal, sexually explicit, racist, that promotes violence, racial hatred,
                <br />
                or terrorism, or that Paramount deems, in its sole discretion, to be otherwise
                objectionable;
              </li>
              <li> frame the Services, display the Services in connection with an unauthorized logo or mark,
                or do anything that could falsely suggest a relationship between Paramount and any third
                party or potentially deprive Paramount of revenue (including revenue from advertising,
                branding, or promotional activities); </li>
              <li> violate any person’s or entity’s legal rights (including intellectual property, privacy, and
                publicity rights), transmit material that violates or circumvents such rights, or remove or
                alter intellectual property or other legal notices; </li>
              <li> transmit files that contain malware, viruses, spyware, adware, or other harmful code; </li>
              <li> advertise or promote goods or services without Paramount’s permission (including by
                sending spam); </li>
              <li> interfere with others using the Services or otherwise disrupt any Services; </li>
              <li> transmit, collect, or access personally identifiable information about other users without
                the consent of those users and Paramount; </li>
              <li> engage in unauthorized spidering, scraping, or harvesting Paramount content, contacts or
                other personal information, or use any other unauthorized automated means to obtain
                Paramount information; </li>
              <li> impersonate any person or entity or otherwise misrepresent your affiliation or the origin
                of materials you transmit; or </li>
              <li> defeat any access controls, access any portion of the Services, any Paramount websites,
                computers or information systems that Paramount has not authorized you to access
                (including password-protected areas), link to password-protected areas, attempt to use
                another user’s account credentials, or allow anyone else to use your account credentials. </li>
            </ol>
          </li>
          <li class="text-white">Access to Services; Account Deletion
            <p>Paramount may monitor your use of the Services at any time. If you submit content of any kind to
              any Service, you grant Paramount a nonexclusive, royalty-free, perpetual right to use; reproduce;
              modify; adapt; publish; translate; create derivative works from; distribute; and display such
              content throughout the world in all media. </p>
            <p>Paramount may take any of the following actions in Paramount’s sole discretion at any time and
              for any reason without any liability and without giving you prior notice: </p>
            <ol type="a" style="margin: 0px 30px;">
              <li>Restrict or terminate your access to any Services; </li>
              <li>Change or discontinue any Services; </li>
              <li>Deactivate your Services accounts and delete all related information and files in your
                accounts; </li>
              <li>Provide information to third parties concerning you and your activities to comply with
                applicable laws or respond to court orders, subpoenas, or other lawful requests, or as
                otherwise described in the privacy policy; and </li>
              <li>Remove Paramount content or user submissions. </li>
            </ol>
          </li>

          <li class="text-white">Cookies and Other Tracking Devices
            <p>
              When you use the Services, Paramount and its service providers may collect certain information
              by automated or electronic means, using technologies such as cookies, pixel tags and web
              beacons, browser analysis tools, and web server logs. As you use the Services and related applications,
              your browser and devices communicate with servers operated by Paramount, its
              business partners, and service providers to operate the Services.
            </p>
          </li>

          <li class="text-white">Disclaimer of Warranties
            <p>
              Paramount does not warrant: (1) that the Services will be uninterrupted or error-free; (2)
              that defects will be corrected; (3) that the Services or the hardware, software or
              information systems hosting or enabling access to them are free of viruses or other
              harmful code; (4) that the Services or information available through the Services will
              continue to be available; (5) that any services or products offered by Third Party Sites are
              accurate, complete or reliable; or (6) or that any personal information collected from Third
              Party Sites will not be exploited. Paramount disclaims any express or implied warranties,
              including non-infringement, merchantability, fitness for a particular purpose, and title. The
              Services including all related hardware, software and information systems made available
              to you are provided “as is,” “as available,” and “with all faults.”
            </p>
            <br />
            <p>
              Your access to and use of the Services is at your risk. If you are dissatisfied with the
              Services or any of the content, your sole and exclusive remedy is to discontinue accessing
              and using the Services.
            </p>
            <br />
            <p>
              Any damages you may incur that arise out of Paramount’s acts or omissions, are not
              irreparable and are not sufficient to entitle you to an injunction or other equitable relief
              restricting exploitation of any website, property, product, program, television show,
              motion picture, or other audio/visual content.
            </p>
            <br />
            <p>
              You acknowledge that you may be waiving rights with respect to claims that are unknown
              or are unsuspected. Accordingly, you hereby waive the benefit of any law, including, to the
              extent applicable, California civil code § 1542, that otherwise might limit your waiver of
              such claims.
            </p>
            <p>
              Some jurisdictions do not allow limitations on implied warranties or the exclusion or
              limitation of certain damages, so some of the above limitations and exclusions may not
              apply to you.
            </p>
          </li>

          <li class="text-white">Limitation of Paramount Liability
            <p>
              Paramount, its affiliates, and their respective vendors, partners, clients, licensees, licensors,
              service providers, third-party content providers, and all officers, directors, shareholders,
              employees and agents have no liability to you or any third party for any loss or damages of any
              kind whatsoever in connection with the Services and any user submissions even if foreseeable or
              even if Paramount has been advised of the possibility of such damages, whether caused in whole
              or in part by Paramount. You hereby assume all risk and liability arising from your use of the
              Services. If any limitation of liability is held to fail its essential purpose or is otherwise deemed to
              be unenforceable, then the maximum cumulative liability of Paramount, arising out of your use
              of the Services, shall not exceed your direct damages, if any. The limitations in this section apply
              to all causes of action. Some jurisdictions do not allow the exclusion or limitation of certain
              damages, so some of the above limitations and exclusions may not apply to you.
            </p>
          </li>

          <li class="text-white"> Indemnification
            <p>
              You must indemnify, defend, and hold harmless Paramount, its affiliates, and their respective
              vendors, partners, clients, licensees, licensors, service providers, third-party content providers,
              and all officers, directors, shareholders, employees and agents of all of the foregoing from and
              against all third party claims, demands, damages, liabilities and costs (including attorneys’ fees)
              arising out of or in connection with: (a) your use of the Services; (b) your breach of this
              Agreement; or (c) your violation of any applicable law as a result of your use of the Services.
              Paramount reserves the right, at its own expense, to assume the exclusive defense and control of
              any matter otherwise subject to indemnification by you, and in such case, you agree to cooperate
              with Paramount’s defense of such claim.
            </p>
          </li>

          <li class="text-white">Choice of Law/Statute of Limitations
            <p>
              These Terms and your use of the Services are governed by the laws of the State of New York, and
              you irrevocably submit to the exclusive jurisdiction for all actions in either of the State of
              California, Los Angeles County, or New York State, New York County, and agree not to plead to
              the contrary. You must bring any claim arising from these Terms within one year from the
              relevant date of your access to the Services that gave rise to the claim.
            </p>
          </li>

          <li class="text-white">Complete Agreement
            <p>
              This Agreement only governs your use of the Services, and other transactions between you and
              Paramount are subject to other applicable agreements, such as advertising sales terms and
              conditions. No changes by you to these Terms are valid without express written consent of
              Paramount in a writing pertaining to these Terms. Paramount may be required by state or
              federal law to notify you of certain events. Notices will be effective upon our delivering them to
              you in writing, which may include email. If you do not provide Paramount with accurate contact
              information, Paramount will not be responsible for failure to notify you. Paramount’s failure to
              exercise or enforce any provision in these Terms will not constitute a waiver of such provision.
              These Terms, including all additional terms, conditions, and policies contained or referenced in a
              mutually executed instrument between you and Paramount constitute the entire agreement
              between you and Paramount and supersede all prior agreements with respect to your use of the
              Services. If any part of these Terms is determined to be invalid or unenforceable under
              applicable law, that provision will be removed and the remainder of the Terms will continue to be
              valid and enforceable.
            </p>
          </li>
        </ol>
      </div>


      <!-- <div>
    
    <p>
    <strong><span class="text-white">PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY
    BEFORE USING THIS WEBSITE</span></strong><span class="text-white"> (the "Site").
    This Site at</span><strong> </strong><strong><span style="color: #ff6633;">
    NickCentral.Nick.com</span></strong><span class="text-white"> is fully controlled
    and operated by Nickelodeon, a business unit of MTV Networks, a division of Viacom
    International, Inc. ("MTVN"). By accessing and using this Site, you are hereby agreeing
    to be legally bound by the terms and conditions of MTVN. If you do not agree with
    all of the following terms and conditions, please do not use this Site<em>.</em></span>
    </p>
    <p>
    <span class="text-white">We reserve the right, at our sole discretion, to change,
    modify or otherwise alter these terms and conditions at any time. Such changes and/or
    modifications shall become effective immediately upon the posting thereof. Please
    review the terms and conditions periodically. Your continued use of the Site following
    the posting of changes and/or modifications will constitute your acceptance of the
    revised terms and conditions. For your information, this page was last updated on</span><strong>
    </strong><strong><span class="text-white">October 17<sup>th</sup> 2012.</span></strong><a name="_GoBack"></a></p>
    <p>
    <strong><span class="text-white">OWNERSHIP OF INTELLECTUAL PROPERTY</span></strong>
    </p>
    <p>
    <span class="text-white">All site software, design, text, images, photographs,
    illustrations, audioclips, videoclips, artwork, graphic material, or other copyrightable
    elements, and the selection and arrangements thereof, and trademarks, service marks
    and trade names (the "Material") are the property of MTVN and/or its subsidiaries,
    affiliates, assigns, licensors or other respective owners and are protected, without
    limitation, pursuant to U.S. and foreign copyright and trademark laws. MTVN hereby
    grants you a personal, non-exclusive, non-assignable and non-transferable license
    to use and display, for noncommercial and personal use only, one copy of any material
    and/or software that you may download from this Site, including, without limitation,
    any files, codes, audio or images incorporated in or generated by the software provided
    that you maintain all copyright and other notices contained in such Material. You
    agree not to reproduce, modify, create derivative works from, display, perform,
    publish, distribute, disseminate, broadcast or circulate any Material to any third
    party (including, without limitation, the display and distribution of the Material
    via a third party website) without the express prior written consent of MTVN. Use
    of MTVN and/or its licensors' Material is only permitted with their express written
    permission. You further agree that you will not disassemble, decompile, reverse
    engineer or otherwise modify the Material. Any unauthorized or prohibited use may
    subject the offender to civil liability and criminal prosecution under applicable
    federal and state laws.</span>
    </p>
    <p>
    <strong><span class="text-white">POSTINGS</span></strong></p>
    <p>
    <span class="text-white">To the extent that portions of this Site provide users
    an opportunity to post and exchange information, ideas and opinions (the "Postings"),
    please be advised that Postings do not necessarily reflect the views of MTVN. In
    no event shall MTVN assume or have any responsibility or liability for any Postings
    or for any claims, damages or losses resulting from their use and/or appearance
    on this Site. You hereby represent and warrant that you have all necessary rights
    in and to all Postings you provide and all information they contain and that such
    Postings shall not infringe any proprietary or other rights of third parties or
    contain any libelous, tortious, or otherwise unlawful information.</span>
    </p>
    <p>
    <span class="text-white">You hereby authorize MTVN to use, and authorize others
    to use, your Postings in whole or in part, throughout the universe in perpetuity
    in any and all media, now known or hereafter devised, alone, or together or as part
    of other material of any kind or nature. Without limiting the foregoing, MTVN will
    have the right to use, edit and change the Postings in any manner that MTVN may
    determine. Additionally, MTVN may sweep its Postings periodically in its sole discretion.</span>
    </p>
    <p>
    <span class="text-white">If you believe that any Postings on this Site violate
    this Agreement or Rules of Participation as referenced on this Site, or otherwise
    infringe upon the rights or any third party, please contact us at </span><strong>
    </strong><a href="mailto:nickcentral@nick.com"><strong style="color: #ff6633;">nickcentral&#64;nick.com</strong></a><span>.</span>
    </p>
    <p>
    <span class="text-white">MTVN does not allow Postings which contain:</span></p>
    <p>
    <span style="font-family: Symbol;color: white;">·</span><span style="font-family: 'Courier New';">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> <span class="text-white">
    profanity or obscenities;</span></p>
    <p>
    <span style="font-family: Symbol; color: white;">·</span><span style="font-family: 'Courier New';">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> <span class="text-white">
    personal attacks on other individuals;</span></p>
    <p>
    <span style="font-family: Symbol;color: white;">·</span><span style="font-family: 'Courier New';">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> <span class="text-white">
    slanderous, defamatory, obscene, pornographic, threatening and harassing comments;
    and/or</span>
    </p>
    <p>
    <span style="font-family: Symbol;color: white;">·</span><span style="font-family: 'Courier New';">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> <span class="text-white">
    other information that MTVN deems in its sole discretion to be inappropriate for
    this Site.</span>
    </p>
    <p>
    <span class="text-white">Although MTVN periodically monitors the content posted
    on this Site, we cannot be responsible for the views or opinions expressed by third
    parties. Nonetheless, MTVN will make every effort to ensure that the Postings best
    serve the interests of all users and, therefore, MTVN reserves the right to refuse
    to post, edit, or delete messages that violate the above-referenced Rules of Participation,
    as well as revoke the privileges of users who do not comply with such rules. If
    you believe that any information provided on this Site violates the Terms and Conditions
    of this Site, or otherwise infringes upon the rights or any third party, please
    contact us at </span><strong> </strong><a href="mailto:nickcentral@nick.com"><strong style="color: #ff6633;">
    nickcentral&#64;nick.com</strong></a><strong><span>.</span></strong></p>
    <p>
    <strong><span class="text-white">OTHER ACTIVITIES</span></strong></p>
    <p>
    <span class="text-white">MTVN may provide Rules of Participation for certain activities
    that may be hosted on this Site. This Agreement will be incorporated by reference
    to the specific Rules of Participation which appear in connection with information
    about a particular activity. To the extent that any conflict exists between this
    Agreement and specific Rules of Participation, the Rules of Participation for the
    activity in which you choose to participate shall govern.</span>
    </p>
    <p>
    <strong><span class="text-white">DISCLAIMER AND LIMITATION OF LIABILITY</span></strong></p>
    <p>
    <span class="text-white">THIS SITE AND ALL MATERIALS CONTAINED ON IT ARE DISTRIBUTED
    AND TRANSMITTED ON AN "AS IS" AND "AS AVAILABLE" BASIS, WITHOUT WARRANTIES OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, WARRANTIES OF MERCHANTABILITY
    OR FITNESS FOR A PARTICULAR PURPOSE. MTVN is not responsible or liable for any infections
    or contamination of your system, or delays, inaccuracies, errors, or omissions arising
    out of your use of this Site or with respect to the information and material contained
    on this Site. The entire risk as to the quality, accuracy, adequacy, completeness,
    correctness and validity of any material rests with you. TO THE FULLEST EXTENT PERMISSIBLE
    PURSUANT TO APPLICABLE LAW, MTVN, ITS AFFILIATES, AND THEIR RESPECTIVE OFFICERS,
    DIRECTORS, EMPLOYEES, AGENTS, LICENSORS, REPRESENTATIVES, AND THIRD PARTY PROVIDERS
    TO THE SITE WILL NOT BE LIABLE FOR DAMAGES OF ANY KIND INCLUDING, WITHOUT LIMITATION,
    COMPENSATORY, CONSEQUENTIAL, INCIDENTAL, INDIRECT, SPECIAL OR SIMILAR DAMAGES, THAT
    MAY RESULT FROM THE USE OF, OR THE INABILITY TO USE, THE MATERIALS CONTAINED ON
    THIS SITE WHETHER THE MATERIAL IS PROVIDED OR OTHERWISE SUPPLIED BY NICKELODEON
    OR ANY THIRD PARTY. Notwithstanding the foregoing, in no event shall MTVN â€™s
    liability to you for any and all claims, damages, losses, and causes of action (whether
    in contract, tort or otherwise) exceed the amount paid by you, if any, for accessing
    this Site.</span>
    </p>
    <p>
    <strong><span class="text-white">THIRD PARTY HYPERLINKS</span></strong>
    </p>
    <p>
    <span class="text-white">The appearance of external hyperlinks and/or Postings
    which may be generated by third parties does not constitute endorsement by MTVN,
    its subsidiaries and affiliates of the opinions or views expressed by these third
    party websites and MTVN does not verify, endorse, or take responsibility for the
    accuracy, currency, completeness or quality of the content contained at these sites.
    Furthermore, MTVN is not responsible for the quality or delivery of the products
    or services offered, accessed, obtained by or advertised at such sites. As such,
    neither MTVN, its subsidiaries and affiliates will be responsible for any errors
    or omissions or for the results obtained from the use of such information contained
    in these sites. Finally, MTVN will under no circumstances be liable for any direct,
    indirect, incidental or special loss or other damage, whether arising from negligence,
    breach of contract, defamation, infringement of copyright or other intellectual
    property rights, caused by the exhibition, distribution or exploitation of any information
    or content contained within these third party hyperlinked sites.</span>
    </p>
    <p>
    <strong><span class="text-white">CONTENT</span></strong>
    </p>
    <p>
    <span class="text-white">
    By uploading content to or downloading content from this website you warrant and undertake that:&nbsp;</span></p>
    <ul class="text-white">
        <li class="first">You have exclusive responsibility for paying and securing any and all clearances and permissions required in respect of any and all third party rights/contributions contained in such content;&nbsp;</li>
        <li class="last">the content does not infringe upon or violate any copyright, trademark or proprietary right of any third party.&nbsp;</li>
    </ul>
    <p class="text-white">Uploading or moderating content shall not be deemed approval of such content by Viacom. Viacom makes no representations or warranties as to the accuracy of the information, the financial and/or marketing outcomes of using such practices as described in any uploaded content available on this website, or the rights of third parties with respect to such content.&nbsp;</p>
    <p class="text-white">All deals, activities and assets remain subject to Viacom’s prior written approval.</p>
    <p>
    <strong><span class="text-white">INDEMNIFICATION</span></strong></p>
    <p>
    <span class="text-white">You agree to indemnify, defend and hold harmless, MTVN,
    its affiliates, and their respective officers, directors, employees, agents, licensors,
    representatives, and third party providers to the Site from and against all losses,
    expenses, damages and costs, including reasonable attorneys' fees, resulting from
    any violation of this agreement by you. MTVN reserves the right to assume, at its
    sole expense, the exclusive defense and control of any matter subject to indemnification
    by you, in which event you will fully cooperate with MTVN in asserting any available
    defenses.</span>
    </p>
    <p>
    <strong><span class="text-white">MISCELLANEOUS</span></strong></p>
    <p>
    <span class="text-white">MTVN operates and controls this Site from its offices
    at 1515 Broadway, New York, New York 10036, United States of America. This Site
    is intended exclusively for residents of the United States. No software from this
    Site may be downloaded, exported or reexported in violation of any law including,
    without limitation, to countries that are subject to U.S. export restrictions.</span></p>
    <p>
    <span class="text-white">This Agreement contains the entire understanding and
    supersedes all prior understanding of the parties hereto relating to the subject
    matter hereof, and cannot be changed or terminated orally. If any provision of this
    Agreement is found to be illegal or unenforceable, the Agreement will be deemed
    curtailed to the extent necessary to make it legal and enforceable and will remain,
    as modified, in full force and effect. This Agreement and all matters or issues
    collateral thereto will be governed by, construed and enforced in accordance with
    the Laws of the State of New York applicable to contracts executed and performed
    entirely therein (without regard to any principles of conflict of laws), and jurisdiction
    for any court action in the State and County of New York.</span></p>
    <p>
    <strong><span class="text-white">Questions and Concerns</span></strong><br>
    <span class="text-white">MTVN is a member of the Viacom family of companies. We
    can be reached by email at </span><strong> </strong><a href="mailto:nickcentral&#64;nick.com">
    <strong style="color: #ff6633;">nickcentral&#64;nick.com</strong></a><strong> </strong><span class="text-white">
    regarding matters relating to this </span><strong> </strong><strong><span style="color: #ff6633;">NickCentral.Nick.com</span></strong><span>
    site<strong>.</strong></span>
    </p>
  
  </div> -->

    </mat-card>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-footer">
  <button mat-button (click)="onCancel()" style="color: white;cursor: pointer;">Close</button>

</mat-dialog-actions>